const definedEntries = (message = {}) => Object.fromEntries(
  Object.entries(message).filter(([, value]) => value !== undefined),
);

export const getChatMessageTimestamp = (message = {}) => {
  const raw = message.created_at ?? message.timestamp ?? message.client_created_at;
  if (typeof raw === "number" && Number.isFinite(raw)) return raw;
  const parsed = Date.parse(raw || "");
  return Number.isFinite(parsed) ? parsed : 0;
};

export const compareChatMessages = (left, right) => {
  const timeDifference = getChatMessageTimestamp(left) - getChatMessageTimestamp(right);
  if (timeDifference !== 0) return timeDifference;

  const leftSequence = Number(left?.sequence);
  const rightSequence = Number(right?.sequence);
  if (Number.isFinite(leftSequence) && Number.isFinite(rightSequence) && leftSequence !== rightSequence) {
    return leftSequence - rightSequence;
  }

  return String(left?.id || "").localeCompare(String(right?.id || ""));
};

const recordsEqual = (left, right) => {
  if (left === right) return true;
  const leftKeys = Object.keys(left || {});
  const rightKeys = Object.keys(right || {});
  return leftKeys.length === rightKeys.length
    && leftKeys.every((key) => left[key] === right[key]);
};

export const mergeChatMessages = (current = [], incoming = [], limit = 100) => {
  const merged = new Map();
  [...current, ...incoming].forEach((message) => {
    if (!message) return;
    const cleanMessage = definedEntries(message);
    const key = String(
      cleanMessage.id
      || `${cleanMessage.user_id || cleanMessage.username || "viewer"}:${cleanMessage.timestamp || cleanMessage.created_at || ""}:${cleanMessage.message || ""}`,
    );
    merged.set(key, { ...(merged.get(key) || {}), ...cleanMessage });
  });

  const ordered = [...merged.values()]
    .sort(compareChatMessages)
    .slice(-Math.max(1, Number(limit) || 100));

  // Recovery snapshots commonly contain the same rows already delivered by
  // WebSocket. Preserve the array reference so React does not redraw the live
  // chat and control surface for a no-op poll.
  if (
    ordered.length === current.length
    && ordered.every((message, index) => recordsEqual(message, current[index]))
  ) {
    return current;
  }
  return ordered;
};

